import { render, staticRenderFns } from "./CenterArea.vue?vue&type=template&id=50cd7bde&scoped=true"
import script from "./CenterArea.vue?vue&type=script&lang=js"
export * from "./CenterArea.vue?vue&type=script&lang=js"
import style0 from "./CenterArea.vue?vue&type=style&index=0&id=50cd7bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd7bde",
  null
  
)

export default component.exports